module.exports = __webpack_public_path__ + "static/portfolio-mas-6-3d2f2b2ffc9b39d333729d891500eec6.jpg";